import { CarrierNames } from 'constants/upiConstants';
import { APPLICATION_NAME, CLIENT_NAME } from './CONSTANT';
import { saveState } from './LocalStorage';
import { getURLParameter } from './nativeSupport';

import JioIcon from 'assets/icons/Autopay/Jio.svg';
import AirtelIcon from 'assets/icons/Autopay/airtel.svg';
import ViIcon from 'assets/icons/Autopay/vi.svg';
import MtnlIcon from 'assets/icons/Autopay/mtnl.svg';
import BsnlIcon from 'assets/icons/Autopay/bsnl.svg';
import DefaultSimIcon from 'assets/icons/Autopay/DefaultSim.svg';
import moment from 'moment';

export const isProd = (): boolean => process.env.NODE_ENV === 'production';

export const isIOS = (): boolean => {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
};

export const showTwelvePcUI = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.TPCLUB;
};

export const showPostPeUI = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.POSTPE;
};

export const showZillionUi = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.ZILLION;
};

export const showUnityUi = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'application');
	const applicationName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('applicationName', applicationName, true);
	return applicationName === APPLICATION_NAME.UNITY_BANK;
};

export const isSwipeClient = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'clientName');
	const clientName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('clientName', clientName, true);
	return clientName === CLIENT_NAME.BHARAT_SWIPE;
};

export const showSurcharge = (): boolean => {
	const encodedName = getURLParameter(window.location.href, 'clientName');
	const clientName = (encodedName && atob(encodedName)) || 'BharatPe';
	saveState('clientName', clientName, true);
	return [CLIENT_NAME.DEPOSIT, CLIENT_NAME.TPCLUB_ADD_MONEY].includes(clientName);
};

export function isEmpty(data: any): boolean {
	try {
		if (data === null || data === undefined || typeof data === 'undefined') {
			return true;
		}

		const dataType = typeof data;
		const keys = Object.keys(data);
		const len = keys.length;
		switch (dataType) {
			case 'string':
				if (data.trim() === '' || data === 'null' || data === null) {
					return true;
				}

				return false;

			case 'object':
				if (len <= 0) {
					return true;
				}

				return false;

			case 'number':
				return false;

			default:
				// for array
				if (Array.isArray(data) && data.length <= 0) {
					return true;
				}

				return false;
		}
	} catch (e) {
		return true;
	}
}

export const getSimLabel = (carrierName: string, slot: number) => {
	const updatedCarrierName = carrierName.toLowerCase();
	if (updatedCarrierName.includes(CarrierNames.Airtel)) {
		return {
			icon: AirtelIcon,
			name: 'Airtel',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Jio)) {
		return {
			icon: JioIcon,
			name: 'Jio',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Vi)) {
		return {
			icon: ViIcon,
			name: 'VI',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Mtnl)) {
		return {
			icon: MtnlIcon,
			name: 'MTNL',
		};
	}
	if (updatedCarrierName.includes(CarrierNames.Bsnl)) {
		return {
			icon: BsnlIcon,
			name: 'BSNL',
		};
	}
	return { icon: DefaultSimIcon, name: `SIM ${slot + 1}` };
};

export const formatMobileNumber = (value: string): string => {
	if (!value) return '';
	return `+91-${value.length == 12 ? value?.substring(2) : value}`;
};

export const formatDate = (timestamp: any): string => {
	return timestamp ? moment(timestamp).format('DD MMM YYYY') : '--';
};

export const formatDateDynamic = (timestamp: any, format: string): string => {
	return timestamp ? `${moment(timestamp).format(format)}` : '';
};
export const formatStringDate = (date: string): string => {
	return date.substring(0, 2) + '/' + date.substring(2, 4) + '/' + date.substring(4, 8);
};

export const textEllipse = (st: string, lenght: number) => {
	return st.substring(0, lenght) + '...';
};
